var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_4)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0001 8.00004C17.0001 8.26526 16.8947 8.51961 16.7072 8.70715C16.5197 8.89469 16.2653 9.00004 16.0001 9.00004H4.41408L8.70808 13.292C8.80106 13.385 8.87481 13.4954 8.92513 13.6169C8.97544 13.7384 9.00134 13.8686 9.00134 14C9.00134 14.1315 8.97544 14.2617 8.92513 14.3832C8.87481 14.5047 8.80106 14.6151 8.70808 14.708C8.6151 14.801 8.50473 14.8748 8.38325 14.9251C8.26177 14.9754 8.13157 15.0013 8.00008 15.0013C7.86859 15.0013 7.73839 14.9754 7.61691 14.9251C7.49543 14.8748 7.38506 14.801 7.29208 14.708L1.29208 8.70804C1.19895 8.61515 1.12507 8.5048 1.07465 8.38331C1.02424 8.26182 0.998291 8.13158 0.998291 8.00004C0.998291 7.86851 1.02424 7.73827 1.07465 7.61677C1.12507 7.49528 1.19895 7.38493 1.29208 7.29204L7.29208 1.29204C7.47985 1.10427 7.73453 0.998779 8.00008 0.998779C8.26563 0.998779 8.52031 1.10427 8.70808 1.29204C8.89585 1.47982 9.00134 1.73449 9.00134 2.00004C9.00134 2.26559 8.89585 2.52027 8.70808 2.70804L4.41408 7.00004H16.0001C16.2653 7.00004 16.5197 7.1054 16.7072 7.29294C16.8947 7.48047 17.0001 7.73483 17.0001 8.00004Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.982b1ef7fc9ef1735ac2f41804b265ca.svg";
export { ForwardRef as ReactComponent };